import React from "react";
import { styled } from "../../theme/styled";
import { Body } from "../typography/Typography";
import { Loader } from "./Loader";

interface Props {
  className?: string;
  /** Text to show under the spinning indicator */
  loadingText?: string;
  position?: "fixed" | "absolute";
}

/**
 * A loader which takes up available screen space and centers itself.
 */
export const FullPageLoader = ({
  className,
  loadingText,
  position = "fixed",
}: Props): React.JSX.Element => {
  return (
    <Wrapper position={position} className={className}>
      <div>
        <Loader aria-label={loadingText} />
      </div>
      {loadingText && <LoaderText size="small">{loadingText}</LoaderText>}
    </Wrapper>
  );
};

const Wrapper = styled("div")<{
  position: Props["position"];
}>(({ position }) => ({
  position: position,
  top: "0",
  left: "0",
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
}));

const LoaderText = styled(Body)({
  marginTop: "$spacing-16",
});
